import MoreInfo from './MoreInfo'

export default MoreInfo
// eslint-disable-next-line import/export
export * from './MoreInfo'
